import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CommonModule } from '@angular/common';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { BackendApiService } from "../../../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../../../app/services/base-url-constants.service";
import { MatButtonModule } from "@angular/material/button";
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import faults from "../../../device-detail-nxt/Faults";
import { ConvertDatetimePipe } from "../../../../../app/convert-datetime.pipe";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import moment from "moment-timezone";
@Component({
  selector: 'app-diagnostics-summary',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, MatFormFieldModule, MatSelectModule, FormsModule],
  templateUrl: './diagnostics-summary.component.html',
  styleUrl: './diagnostics-summary.component.scss'
})
export class DiagnosticsSummaryComponent implements OnInit {
  @Input() data: any;
  public clientId: string | null = null;
  public loadingDiagnoseSummary: boolean = false;
  public summary: any = null;
  public FFTId: string | null = null;
  public KurtosisId = sessionStorage.getItem('KurtosisId')
  public loadingFFTList: boolean = false;
  public fftList: any = null;
  public role = localStorage.getItem('role');
  public finalFaults: any[] = [];
  public driveType: string | null = 'DIRECT';
  public loadingOnDemandSA: boolean = false;

  public colorHealthy = '#74FA18';
  public colorUnsatisfactory = '#faa700';
  public colorUnacceptable = '#f3291c';

  constructor(private service: BackendApiService) {
    this.clientId = localStorage.getItem('user_id');
  }

  ngOnInit(): void {
    console.log('Component initialized with data:', this.data);
    console.log('Client ID:', this.clientId);

    if (this.data?.assetId && this.clientId) {
      this.fetchFFTList(false);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      if (this.data?.assetId) {
        this.fetchDriveDetails();
        // If summary exists, re-process faults with new asset data
        if (this.summary) {
          this.processFaults();
        }
      }
    }
  }

  async fetchDriveDetails() {
    if (!this.data?.assetId) return;
    try {
      // Replicating: diagnostics/diagnostics/getDriveDetails/${assetId}
      const apiUrl = `${BaseUrlConstantsService.GET_DRIVE_DETAILS_API}/${this.data.assetId}`;
      const response: any = await this.service.getDataV2(apiUrl); // Adjust method if needed

      if (response?.data?.status === "success" && response?.data?.body) {
        this.driveType = response.data.body.drive_type;
      } else if (this.data.assetType === 'GEAR') {
        this.driveType = null;
      } else {
        this.driveType = 'DIRECT';
      }

      // Re-process faults if we have summary data, as driveType affects the result
      if (this.summary) this.processFaults();

    } catch (error) {
      console.error("Failed to fetch drive details:", error);
      this.driveType = 'DIRECT';
    }
  }

  async fetchDiagnoseSummary() {
    try {
      this.loadingDiagnoseSummary = true;
      const apiUrl = `${BaseUrlConstantsService.PIEZO_DIAGNOSTICS_SUMMARY_API}${this.clientId}/${this.data.inventoryId}/${this.data.assetId}?type=${this.data.assetType}&fft_id=${this.FFTId}&bearing_id=${this.KurtosisId}`
      const response: any = await this.service.getDataV2(apiUrl)
      this.summary = response.body;

      // 4. CONVERT DATES IN TS
      if (this.summary) {
        // Convert Vibration Faults Date
        if (this.summary.vibrationfaults?.updated_at) {
          this.summary.vibrationfaults.updated_at = new ConvertDatetimePipe().convertDateTime(moment.utc(this.summary?.vibrationfaults?.updated_at).toDate());
        }
        // Convert Early Stage Date
        if (this.summary.earlyStageBallBearing?.updated_at) {
          this.summary.earlyStageBallBearing.updated_at = new ConvertDatetimePipe().convertDateTime(moment.utc(this.summary?.earlyStageBallBearing?.updated_at).toDate());
        }
        // Convert ESA Date
        // if (this.summary.esaFaults?.updated_at) {
        //   this.summary.esaFaults.updated_at = new ConvertDatetimePipe().convertDateTime(moment.utc(this.summary?.esaFaults?.updated_at).toDate());
        // }
      }

      this.processFaults();
    }
    catch (error) {
      console.log(error)
    }
    finally {
      this.loadingDiagnoseSummary = false;
    }
  }

  async fetchFFTList(selectNewest: boolean = false) {
    try {
      this.loadingFFTList = true;
      const apiUrl = `${BaseUrlConstantsService.PIEZO_DIAGNOSTICS_FFT_LIST_API}${this.data.inventoryId}/${this.data.assetId}?userId=${this.clientId}&role=${this.role}&assetType=${this.data.assetType}`
      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.data?.status === "success") {
        this.fftList = response.data.body || [];

        // 5. CONVERT DATES FOR DROPDOWN IN TS
        if (this.fftList.length > 0) {
          this.fftList.forEach((item: any) => {
            if (item.fft_time) {
              item.fft_time = new ConvertDatetimePipe().convertDateTime(item.fft_time);
            }
          });
        }

        if (this.fftList.length > 0) {
          if (selectNewest) {
            this.FFTId = this.fftList[0].value;
            sessionStorage.setItem('FFTId', String(this.FFTId));
          }
          else {
            const sessionFFTId = sessionStorage.getItem('FFTId');
            const foundItem = this.fftList.find((item: any) => String(item.value) === String(sessionFFTId));

            if (foundItem) {
              this.FFTId = foundItem.value;
            } else {
              this.FFTId = this.fftList[0].value;
              sessionStorage.setItem('FFTId', String(this.FFTId));
            }
          }
          this.fetchDiagnoseSummary();
        }
      } else {
        this.fftList = [];
      }
    }
    catch (error) { console.log(error) }
    finally { this.loadingFFTList = false; }
  }

  onHistoryChange(event: any) {
    this.FFTId = event.value;
    sessionStorage.setItem('FFTId', this.FFTId);
    this.fetchDiagnoseSummary();
  }

  getTagClass(text: string, type: number) {
    if (!text || text.trim() === "") return "green";
    if (text.length > 0 && type === 1) return "red";
    if (text.length > 0 && type === 2) return "yellow";
    return "green";
  }

  processFaults() {
    console.log("this.summary ----->", this.summary);
    console.log("this.data ----->", this.data);
    // Safety check: ensure summary and data exist
    if (!this.summary || !this.data) return;

    // 1. Normalize Inputs to UpperCase for comparison
    const assetType = this.data.assetType ? this.data.assetType.toUpperCase() : '';
    const subAssetType = this.data.subAssetType ? this.data.subAssetType.toUpperCase() : null;

    console.log('Processing Faults for:', assetType, subAssetType); // Debugging log

    // 2. Filter faults based on asset type (Robust Matching)
    const assetErrors: any[] = [];

    // Check if 'faults' imported correctly
    if (!faults || faults.length === 0) {
      console.warn('Faults constant is empty or not imported');
      return;
    }

    faults.forEach((fault: any) => {
      // Ensure fault.assets are also compared in UpperCase
      const faultAssets = fault.assets.map((a: string) => a.toUpperCase());

      if (subAssetType != null && assetType === 'MOTOR') {
        if (faultAssets.includes(subAssetType)) {
          assetErrors.push(fault);
        }
      } else {
        if (faultAssets.includes(assetType)) {
          assetErrors.push(fault);
        }
      }
    });

    console.log('Configured Asset Errors Found:', assetErrors.length); // Should be > 0

    // 3. Helper to split fault strings
    const parseFaults = (text: string | undefined | null) => {
      if (!text) return [];
      return text.split(",").flatMap((err) => {
        let arr2 = err.split("or");
        return arr2.map((item) => item.trim());
      });
    };

    // 4. Collect API Responses
    const mechObservable = parseFaults(this.summary.vibrationfaults?.mechanicalFaults?.observeableError);
    const elecObservable = parseFaults(this.summary.vibrationfaults?.electricalFaults?.observeableError);
    const bearingObservable = parseFaults(this.summary.vibrationfaults?.bearingFaults?.observeableError);
    const cepstrumFault = parseFaults(this.summary.vibrationfaults?.cepstrum_mssg);
    const finalObservableErrors = [...new Set([...mechObservable, ...elecObservable, ...bearingObservable, ...cepstrumFault])];

    const mechPredominant = parseFaults(this.summary.vibrationfaults?.mechanicalFaults?.predominantError);
    const elecPredominant = parseFaults(this.summary.vibrationfaults?.electricalFaults?.predominantError);
    const bearingPredominant = parseFaults(this.summary.vibrationfaults?.bearingFaults?.predominantError);
    const ballBearingEarly = parseFaults(this.summary.earlyStageBallBearing?.ballBearingErrorMessage);
    const finalDominantErrors = [...new Set([...mechPredominant, ...elecPredominant, ...bearingPredominant, ...ballBearingEarly])];

    // 5. Categorize (Red/Yellow)
    const yellowErr: any[] = [];
    const redErr: any[] = [];

    assetErrors.forEach((err) => {
      // Yellow Check
      for (let j = 0; j < finalObservableErrors.length; j++) {
        if (finalObservableErrors[j].includes(err.key) && finalObservableErrors[j] !== "") {
          yellowErr.push({ fault: err.key, error: err.faults, group: err.faultGroup, color: "yellow" });
        }
      }
      // Red Check
      for (let j = 0; j < finalDominantErrors.length; j++) {
        if (finalDominantErrors[j].includes(err.key) && finalDominantErrors[j] !== "") {
          redErr.push({ fault: err.key, error: err.faults, group: err.faultGroup, color: "red" });
        }
      }
    });

    // 6. Calculate Green (Healthy) - Crucial Step
    const finalErrors = [...yellowErr, ...redErr];
    const combinedFaultKeys = finalErrors.map((err) => err.fault);
    const assetErrorKeys = assetErrors.map((err) => err.key);

    // Find items in config (assetErrors) that are NOT in Red/Yellow lists
    const uncommon = assetErrorKeys
      .filter((value) => !combinedFaultKeys.includes(value));

    const greenErrors: any[] = [];
    assetErrors.forEach((err) => {
      if (uncommon.includes(err.key)) {
        greenErrors.push({ fault: err.key, error: err.faults, group: err.faultGroup, color: "green" });
      }
    });

    // 7. Combine & Filter Drive Type
    let finalErrorsArray = [...redErr, ...yellowErr, ...greenErrors];

    if (this.driveType === "DIRECT") {
      finalErrorsArray = finalErrorsArray.filter((err) => err.group !== "Belt System");
    }

    console.log("finalErrorsArray ----->", finalErrorsArray);

    this.finalFaults = finalErrorsArray;
  }

  async onDemandSA() {
    try {
      this.loadingOnDemandSA = true;
      const apiUrl = `${BaseUrlConstantsService.PIEZO_DIAGNOSTICS_ON_DEMAND_SA_API}${this.data.inventoryId}/${this.data.assetId}?userid=${this.clientId}&asset_type=${this.data.assetType}&fft_id=${this.FFTId}&bearing_id=${this.KurtosisId}`
      const response: any = await this.service.getDataV2(apiUrl)
      if (response?.data?.status === "success") {
        this.fetchFFTList(true);
        this.fetchDiagnoseSummary();
        this.processFaults();
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.loadingOnDemandSA = false;
    }
  }
}
